import React, { Component, Fragment } from 'react';
import { Link } from 'react-router';
import ReactPaginate from 'react-paginate';
import Alert from 'components/alerts/Alert/Alert';
import moment from 'moment-timezone';

import { flags } from 'config/languages';
import './style.css';

class StudentReservationHistory extends Component {
  changePage = (data) => {
    this.setState({ currentPage: data.selected });
    this.props.handlePaginationClick(data);
  }

  formatListingTitle = () => {
    const {
      total, page, pageSize, reservations
    } = this.props;
    const pageStart = page * pageSize + 1;
    const pageEnd = pageStart + (reservations.length || 0) - 1;

    return `${pageStart} – ${pageEnd} of ${total} Lesson${
      total === 1 ? '' : 's'
    }`;
  }

  renderActionLinks(reservation) {
    const _30MinsAgo = moment().subtract(30, 'minutes').valueOf();
    const _1MonthAgo = moment().subtract(1, 'months').valueOf();
    const startTime = moment.utc(reservation.startTime).valueOf();
    const canReportProblem = !reservation.issue && startTime < _30MinsAgo && startTime > _1MonthAgo;
    const canCreateRating = !reservation.rating && startTime < _30MinsAgo && startTime > _1MonthAgo;

    return (
      <Fragment>
        {reservation.issue && (
          <Fragment>
            <span className="long-issue-label hide-on-mobile">Issue reported</span>
            <span className="short-issue-label show-on-mobile">Reported</span>
          </Fragment>
        )}
        {canReportProblem && (
          <Link
            className="action-link"
            to={`/report-problem?aid=${reservation.id}`}
          >
            <span className="long-issue-label hide-on-mobile">Report problem</span>
            <span className="short-issue-label show-on-mobile">Report</span>
          </Link>
        )}
        {(reservation.issue || canReportProblem) && (
          <span className="action-separator hide-on-mobile">|</span>
        )}
        {reservation.rating && (
          <Link
            className="action-link"
            onClick={(event) => {
              event.preventDefault();
              this.props.handleRateClick(reservation);
            }}
          >
            <span>
              <i style={{ color: '#fc6', marginRight: 2 }} className="fa fa-star" />
              {reservation.rating}
            </span>
          </Link>
        )}
        {canCreateRating && (
          <Link
            className="action-link"
            onClick={(event) => {
              event.preventDefault();
              this.props.handleRateClick(reservation);
            }}
          >
            <span>Rate</span>
          </Link>
        )}
      </Fragment>
    );
  }

  render() {
    const {
      reservations, total, page, pageSize
    } = this.props;
    const _30MinsAgo = moment().subtract(30, 'minutes').valueOf();
    const _1MonthAgo = moment().subtract(1, 'months').valueOf();

    return (
      <div className="student-reservation-history">
        {reservations.length > 0 ? (
          <Fragment>
            <table className="table">
              <thead>
                <tr>
                  <th scope="col">Status</th>
                  <th scope="col">Teacher</th>
                  <th scope="col" className="hide-on-mobile">Skype</th>
                  <th scope="col">Date</th>
                  <th scope="col" className="hide-on-mobile">Language</th>
                  <th scope="col" />
                </tr>
              </thead>
              <tbody>
                {reservations.map(reservation => {
                  return (
                    <tr key={reservation.id}>
                      <th scope="row">
                        {reservation.statusForClient === 'Booked' &&
                          <strong><span className="upcoming-title">Upcoming</span></strong>}
                        {reservation.statusForClient !== 'Booked' &&
                          <span>{reservation.statusForClient}</span>}
                      </th>
                      <td>
                        <img
                          className="flag show-on-mobile-inline"
                          src={`/assets/country/${flags[reservation.service.description]}`}
                          alt={flags[reservation.service.description]}
                        />
                        <span>{reservation.teacher.name}</span>
                      </td>
                      <td className="hide-on-mobile">{reservation.teacher.skypeName}</td>
                      <td>
                        {moment
                          .utc(reservation.startTime)
                          .local()
                          .format('MMM DD, YYYY h:mma')}
                      </td>
                      <td className="hide-on-mobile">{reservation.service.description}</td>
                      <td>{this.renderActionLinks(reservation)}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            {page >= 0 && (
              <ReactPaginate
                previousLabel={'<'}
                nextLabel={'>'}
                pageCount={total / pageSize}
                forcePage={page}
                marginPagesDisplayed={total / pageSize}
                pageRangeDisplayed={1}
                onPageChange={this.changePage}
                containerClassName="pagination"
                subContainerClassName="pages pagination"
                activeClassName="active"
              />
            )}
          </Fragment>
        ) : (
          <Alert alertType="warning" className="mt-2">
            <h4>No reservations</h4>
          </Alert>
        )}
      </div>
    );
  }
}

export default StudentReservationHistory;



// WEBPACK FOOTER //
// ./src/components/StudentReservationHistory/index.js